import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { css } from "styled-components";

actionStyles.buttonWrapper = mergeToNew(actionStyles.buttonWrapper, {
    css: css`
        gap: 10px;
    `,
});
